import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import {
  Typography, DatePicker, Select, List, Tag, Space,
} from 'antd';
import { useUserEvents } from 'hooks/api';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

const REFERRER_COLORS: Record<string, string> = {
  instagram: 'magenta',
  'instagram-ads': 'volcano',
  'google-merchant': 'geekblue',
  'google-ads': 'cyan',
  tiktok: 'purple',
  pubgcarddelivery: 'gold',
};

const EVENT_TYPE_COLORS: Record<string, string> = {
  preview: 'blue',
  productPreview: 'blueviolet',
  addToCard: 'green',
  checkoutPage: 'orange',
  checkoutProcess: 'red',
  checkoutPhone: 'volcano',
  search: 'geekblue',
};

const UserEventLog = () => {
  const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null] | null>(null);
  const [type, setType] = useState<string | undefined>(undefined);

  const params = {
    type,
    dateFrom: dateRange?.[0]?.startOf('day').toISOString(),
    dateTo: dateRange?.[1]?.endOf('day').toISOString(),
  };

  const { data: events = [], isLoading } = useUserEvents(params);

  return (
    <div>
      <Title level={2}>User Event Log</Title>

      <Space wrap style={{ marginBottom: 16 }}>
        <Space direction='vertical' size={4}>
          <Text type='secondary'>Тип події</Text>
          <Select
            allowClear
            placeholder='Всі типи'
            value={type}
            onChange={setType}
            style={{ width: 200 }}
          >
            <Option value='preview'>preview</Option>
            <Option value='productPreview'>productPreview</Option>
            <Option value='addToCard'>addToCard</Option>
            <Option value='checkoutPage'>checkoutPage</Option>
            <Option value='checkoutProcess'>checkoutProcess</Option>
            <Option value='checkoutPhone'>checkoutPhone</Option>
            <Option value='search'>search</Option>
          </Select>
        </Space>

        <Space direction='vertical' size={4}>
          <Text type='secondary'>Період</Text>
          <RangePicker
            onChange={(dates) => setDateRange(dates as [Dayjs | null, Dayjs | null] | null)}
            format='DD.MM.YYYY'
          />
        </Space>
      </Space>

      <List
        loading={isLoading}
        dataSource={events}
        locale={{ emptyText: 'Подій не знайдено' }}
        renderItem={(item: any) => (
          <List.Item>
            <List.Item.Meta
              title={(
                <Space>
                  <Tag color={EVENT_TYPE_COLORS[item.type] || 'default'}>{item.type}</Tag>
                  <Text code>{item.ip}</Text>
                  {item.label && <Text strong>{item.label}</Text>}
                  {item.referrer && <Tag color={REFERRER_COLORS[item.referrer] || 'default'}>{item.referrer}</Tag>}
                </Space>
              )}
              description={(
                <Text type='secondary' style={{ fontSize: 12 }}>
                  {dayjs(item.createdAt).format('DD.MM.YYYY HH:mm:ss')}
                </Text>
              )}
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default UserEventLog;
